import React from 'react';
import Select from 'react-select';
class TemplateDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
    }
    //this.selected="Dropdown"
  }


  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
    this.props.selected(selectedOption)
  }

  render() {

    if (this.props.predefinedSection) {
      this.options = this.props.predefinedSection.map((el) => {
        let dropdownObject = Object.assign({}, el);
        dropdownObject.label = dropdownObject.displayName;
        dropdownObject.value = dropdownObject.id//o.name;
        return dropdownObject;
      })

    }
    if (this.props.dataSection) {
      this.options = this.props.dataSection.map((el) => {
        let dropdownObject = Object.assign({}, el);
        dropdownObject.label = dropdownObject.displayName;
        dropdownObject.value = dropdownObject.id//o.name;
        return dropdownObject;
      })

    }

    const { selectedOption } = this.state;
    const { isMulti } = this.props
    return (
      <div className="mt-2">
        <Select
          value={selectedOption}
          onChange={this.handleChange}
          options={this.options}
          isMulti={isMulti}
        />
      </div>
    );
  }
}



export default TemplateDropdown;